import SmilesDrawer from 'smiles-drawer';

const options = {
  debug: false,
  atomVisualization: 'default'
};

const smilesDrawer = new SmilesDrawer.Drawer(options);
const svgDrawer = new SmilesDrawer.SvgDrawer(options);

export const SD = {
  drow: function(content: string) {
    console.log('[MMD] drow=> content=>', content);
    // let t = performance.now();
    var log = document.getElementById('log');

    smilesDrawer.parse(content, (tree) => {
      debugger;
      svgDrawer.draw(tree, 'output-svg', 'dark', false);
      // let td = performance.now() - t;
      // log.innerHTML = '&nbsp;';
      // log.style.visibility = 'hidden';

      // new Noty({
      //   text: 'Drawing took ' + td.toFixed(3) + 'ms with a total overlap score of ' + svgDrawer.getTotalOverlapScore().toFixed(3) + '.',
      //   killer: true,
      //   timeout: 2000,
      //   animation: {
      //     open: null,
      //     close: null
      //   }
      // }).show();

      console.log(svgDrawer.getMolecularFormula());

    }, function (err) {
      log.innerHTML = err;
      log.style.visibility = 'visible';
      console.log(err);
    })
  }
};
